export const ACTIVITY_ENTITY_TYPE_LABELS = {
	companies: 'Компания',
	company_group_links: 'Связанные площадки',
	company_params: 'Параметры площадки',
	company_postponements: 'Статус',
	worths: 'Ценность',
	personal_contacts: 'Контакты',
	personal_contact_numbers: 'Контакты',
	company_general_numbers: 'Контакты',
	meetings: 'Встречи',
	messaging: 'Переписка',
	calls: 'Звонки',
	contracts: 'Договоры',
	documents: 'Документы',
	files: 'Файлы',
	objections: 'Возражения',
	activities: 'События',
	activity_items: 'Элементы события',
	users: 'Пользователи',
};

export const normalizeActivityEntityType = (value) => {
	if (!value) return '';

	if (typeof value === 'object' && value.value) {
		return String(value.value).toLowerCase();
	}

	return String(value).toLowerCase();
};

export const getActivityEntityTypeLabel = (value) => {
	const key = normalizeActivityEntityType(value);

	return ACTIVITY_ENTITY_TYPE_LABELS[key] ?? key;
};

/** GraphQL EntityType enum name from backed value / any casing. */
export const toActivityEntityTypeEnum = (value) => {
	return normalizeActivityEntityType(value).toUpperCase();
};

export const formatActivityFilterChipValue = (selectedLabels) => {
	if (!selectedLabels?.length) return 'Все';
	if (selectedLabels.length === 1) return selectedLabels[0];
	if (selectedLabels.length <= 2) return selectedLabels.join(', ');

	return `Выбрано: ${selectedLabels.length}`;
};
